// docs: https://github.com/altostra/type-validations#readme
import { anyOf, objectOf } from "@altostra/type-validations";
import { boolean, number, string, nullValidation } from "@altostra/type-validations/lib/primitives";

const isComponentConstraint = objectOf({
  component: string,
  period: number,
  times: number,
  guardrail_id: string,
  active: boolean,
  updated_at: anyOf(string, nullValidation),
});

export const isGetDecisioningStudioAgentsAppGroupIdDsaIdConstraintsComponentResult = anyOf(
  isComponentConstraint,
  nullValidation
);

export const isPostDecisioningStudioAgentsAppGroupIdDsaIdConstraintsComponentResult = isComponentConstraint;

export const isPutDecisioningStudioAgentsAppGroupIdDsaIdConstraintsComponentResult = isComponentConstraint;
